"use client"
import { Moon, Sun, Monitor } from "lucide-react"

import { useEffect, useState } from "react"

import { Button } from "@/components/ui/button"
import { useTheme } from "./theme-provider"

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  // Wait until after client-side hydration to show UI
  useEffect(() => {
    setMounted(true)
  }, [])

  const toggleTheme = () => {
    if (theme === "light") {
      setTheme("dark")
    } else {
      setTheme("light")
    }
  }

  // Don't render anything until the component has mounted on the client
  if (!mounted) {
    return (
      <Button variant="outline" size="icon" className="rounded-xl transition-transform duration-100 ease-in-out active:scale-95 hover:scale-105">
        <div className="h-[1.2rem] w-[1.2rem]" />
        <span className="sr-only">Toggle theme</span>
      </Button>
    )
  }

  return (
    <Button variant="ghost" size="icon" onClick={toggleTheme} className="hover:animate-in rounded-xl transition-transform duration-100 ease-in-out active:scale-95 hover:scale-105">
      <Sun className={`h-[1.2rem] w-[1.2rem] absolute transition-all text-black ${
        theme === "light" ? "rotate-0 scale-100" : "rotate-90 scale-0"
      }`} />
      <Moon className={`h-[1.2rem] w-[1.2rem] absolute transition-all ${
        theme === "dark" ? "rotate-0 scale-100" : "-rotate-90 scale-0"
      }`} />
      <span className="sr-only">Toggle theme</span>
    </Button>
  )
}